
import Vue from 'vue';
import Component from 'vue-class-component';
import SectionLayout from '@/components/SectionLayout.vue';
import { noop } from 'rxjs';
import { navLightTheme } from '@/components/NavBar/navbar-theme';

@Component({
  components: {
    SectionLayout
  }
})
export default class HomeAbout extends Vue {
  animate() {
    noop();
  }
}
